import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import "./FloatingButtons.css";
import emailjs from "emailjs-com";

export default function EnquiryButton() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      message: formData.message,
    };

    emailjs
      .send(
        "service_8zzykj8",
        "template_cw87jni",
        templateParams,
        "I8gKRp0YvJkXLUqEc"
      )
      .then(
        (result) => {
          // ✅ Successful submission
          console.log(result.text);

          // Show beautiful SweetAlert popup
          Swal.fire({
            title: "Message Sent!",
            text: "✅ Your enquiry has been successfully sent.",
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "OK",
          }).then(() => {
            // Close the modal after alert
            handleClose();

            // Clear form
            setFormData({ name: "", email: "", phone: "", message: "" });
          });
        },
        (error) => {
          console.error(error.text);

          Swal.fire({
            title: "Oops!",
            text: "❌ Failed to send message. Please try again.",
            icon: "error",
            confirmButtonColor: "#d33",
            confirmButtonText: "OK",
          });
        }
      );
  };

  return (
    <>
      {/* Floating Button */}
      <button className="enquiry-side-btn" onClick={handleShow}>
        Enquire Now
      </button>

      {/* Modal */}
      <Modal
        className="modal-settings"
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Enquiry Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit} style={{ padding: "20px" }}>
            <div className="mb-3">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                name="name"
                id="name"
                autoComplete="off"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                className="form-control"
                style={{ color: "#000" }}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                name="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                className="form-control"
                style={{ color: "#000" }}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                name="phone"
                id="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone"
                className="form-control"
                style={{ color: "#000" }}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="message">Message</label>
              <textarea
                name="message"
                id="message"
                rows={3}
                value={formData.message}
                onChange={handleChange}
                placeholder="Type your message"
                className="form-control"
                style={{ color: "#000" }}
                required
              ></textarea>
            </div>
          </form>
        </Modal.Body>

        <div className="text-center pb-3">
          <Button
            variant="primary"
            className="enq-button"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </Modal>
    </>
  );
}
